<template>
  <div class="headerWrap">
    <div class="header">
      <div class="tabBar">
        <span>
          <img src="@/assets/logo.png" @click="$router.push('/home')" class="hover" />
        </span>
      </div>
      <div class="productTitle">
        <a-popover
          v-if="printImgInfo.name"
          placement="bottom"
          :visible="explainVisible"
          :trigger="['hover']"
          overlayClassName="explainOverlayWrap"
          @visibleChange="explainVisibleChange"
        >
          <template slot="content">
            <div class="explainCt">
              {{ $t('design.productHover') }}
            </div>
          </template>
          <span class="name" @click="$emit('upIsShowDetail')">{{ printImgInfo.en_name }}</span>
        </a-popover>

        <span class="money">
          <span
            class="price"
            v-if="priceData.is_promotion === 1 && +priceData.promotion_price < +priceData.purchase_price"
            >{{ (priceData.promotion_price ? priceData.promotion_price : '') | rateAmountLocal }}</span
          >
          <span class="price" v-else
            >{{ (priceData.purchase_price ? priceData.purchase_price : '') | rateAmountLocal }}
          </span>
        </span>
      </div>
      <div class="userName">
        <template v-if="printImgInfo.is_brand === 1">
          <span class="spItem ml20" v-if="!isReDesign">
            <a
              class="saveBtn"
              @click="$emit('backBrandSave')"
              style="width: 150px; background: #FFA200; color: #FFFFFF;"
              >Save</a
            >
          </span>
          <span class="spItem ml20" v-if="!isReDesign">
            <a
              class="saveBtn"
              @click="$router.push('/personal_center/brand')"
              style="width: 150px; background: #ccc;border: 1px solid #ccc;
              color: #fff;"
              >Cancel</a
            >
          </span>
          <span class="spItem ml20" v-if="isReDesign">
            <a class="reDesignSaveBtn" style="background: #ffa200" @click="$emit('reDesignSave')" v-if="isReDesign"
              >Save</a
            >
          </span>
          <span class="spItem ml20" v-if="isReDesign">
            <a class="reDesignSaveBtn" style="background: #d9d9d9" @click="$emit('reDesignCancel')">Cancel</a>
          </span>
        </template>
        <template v-else>
          <span class="spItem ml20" v-if="!isReDesign">
            <a class="saveBtn" @click="$emit('backPublish')" style="width: 150px">Save and publish</a>
          </span>
          <span class="spItem ml20" v-if="!isReDesign">
            <a class="saveBtn" @click="$emit('backSave')" style="width: 120px;">{{ $t('design.saveProduct') }}</a>
          </span>
          <span class="spItem ml20" v-if="!isReDesign">
            <a class="saveBtn" @click="$emit('backAddShop')" style="background: #FFA200; color: #FFFFFF;"
              >Add to cart</a
            >
          </span>
          <span class="spItem ml20" v-if="isReDesign">
            <a class="reDesignSaveBtn" style="background: #ffa200" @click="$emit('reDesignSave')" v-if="isReDesign"
              >Save</a
            >
          </span>
          <span class="spItem ml20" v-if="isReDesign">
            <a class="reDesignSaveBtn" style="background: #d9d9d9" @click="$emit('reDesignCancel')">Cancel</a>
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import Tip from '@/layouts/tip/index.vue'
export default {
  name: 'ViewsLayout',
  data() {
    return {
      activeBar: '',
      isTrue: false,
      groupKey: '',
      searchCondition: {
        total: 1,
        per_page: 6,
        page: 1
      },
      explainVisible: true
    }
  },
  props: ['fullscreen', 'isReDesign'],
  methods: {
    ...mapActions(['Logout']),
    ...mapMutations({
      setRandom: 'SET_RANDOM',
      setCanvasType: 'SET_CANVAS_TYPE'
    }),
    explainVisibleChange(val) {
      this.explainVisible = val
    },
    goOther(path) {
      this.$router.push(path.path)
      this.activeBar = ''
    },
    loginOut() {
      // this.Logout()
    }
  },
  watch: {},
  components: {
    Tip
  },
  computed: {
    ...mapState({
      info: state => state.user.info,
      routers: state => state.user.routers,
      cartTotal: state => state.user.cartTotal,
      parentIdMap: state => state.user.parentIdMap,
      groupData: state => state.user.groupData,
      printImgInfo: state => state.design.printImgInfo,
      priceData: state => state.design.priceData
    }),
    ...mapGetters(['rightMenu', 'activeFabric'])
  },
  mounted() {
    setTimeout(() => {
      this.explainVisible = false
    }, 4000)
  },
  created() {
    const { routers } = this
    if (this.$route.path === '/personal_center/guide') {
      this.activeBar = '首页'
      return
    }
    for (let i = 0; i < routers.length; i++) {
      const route = routers[i]
      if (
        route.children.filter(it => {
          return it.name === this.$route.name
        }).length
      ) {
        this.activeBar = route.meta.title
      }
    }
  }
}
</script>

<style lang="less" scoped>
.headerWrap {
  background: #ffffff;
}
.router-wrap {
  overflow: hidden;
  padding: 6px 0;
  border-radius: 5px;
  width: 120px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  .routerItem {
    line-height: 32px;
    text-align: center;
    cursor: pointer;
    &:hover {
      background: #ddecf9;
    }
  }
}
.header {
  padding: 0 20px;
  height: 55px;
  margin: 0 auto;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .tabBar {
    display: flex;
    padding-right: 20px;
    align-items: center;
    justify-content: space-between;
    font-size: 0;
  }
  .userName {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .buyBtn {
      display: inline-block;
      height: 32px;
      padding: 0 50px;
      background: #1890ff;
      border-radius: 12px;
      line-height: 32px;
      border: none;
      color: white;
      text-align: center;
    }
    .cart-sp {
      position: relative;
      cursor: pointer;
      .badge-wrap {
        position: absolute;
        top: -10px;
        right: 10px;
      }
    }
  }
  .spItem {
    position: relative;
    font-size: 14px;
    color: #666;
    &.ml20 {
      margin-left: 20px;
    }
    &.ml30 {
      margin-left: 20px;
    }
    &.ml80 {
      margin-left: 80px;
    }
    &.pointer {
      cursor: pointer;
    }
    .recordBg {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 98;
    }
    .recordWrap {
      // display: none;
      visibility: hidden;
      position: absolute;
      top: 100%;
      left: 50%;
      width: 350px;
      padding: 20px;
      margin-left: -175px;
      background: #fff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      z-index: 99;
      &.hover {
        // display: block;
        visibility: visible;
      }
    }
    .rdTop {
      display: flex;
      justify-content: space-between;
      span {
        font-size: 12px;
        color: #666;
      }
    }
    .rdBody {
      margin: 0 -10px;
      .rdItem {
        position: relative;
        float: left;
        width: 90px;
        height: 90px;
        margin: 10px 10px 0 10px;
        background: #000;
        h5 {
          visibility: hidden;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          margin: 0;
          font-size: 14px;
          color: #fff;
          background: rgba(0, 0, 0, 0.5);
          text-align: center;
        }
        &:hover {
          h5 {
            visibility: visible;
          }
        }
      }
    }
  }
  .saveBtn {
    display: inline-block;
    width: 88px;
    height: 32px;
    border-radius: 4px;
    font-size: 14px;
    color: #ffa200;
    line-height: 32px;
    background: #ffffff;
    text-align: center;
    border: #ffa200 1px solid;
  }
  .reDesignSaveBtn {
    display: inline-block;
    width: 88px;
    height: 32px;
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    line-height: 32px;
    text-align: center;
  }
  .productTitle {
    flex: 1;
    justify-content: center;
    display: flex;
    text-align: center;
    .name {
      overflow: hidden;
      display: inline-block;
      height: 30px;
      font-size: 20px;
      color: #666;
      max-width: 500px;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
    }
    .money {
      display: inline-block;
      font-size: 20px;
      vertical-align: 6px;
      color: #ff0000;
      img {
        height: 20px;
        margin-left: 4px;
        vertical-align: -2px;
      }
    }
  }
}
.ant-dropdown-menu-item {
  text-align: center !important;
}
.contentWrap {
  width: 370px;
  img {
    width: 100%;
  }
}
</style>
